import { render } from "./Expired.vue?vue&type=template&id=afeda396"
import script from "./Expired.vue?vue&type=script&lang=js"
export * from "./Expired.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__